// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38IZX","name":"styles_name__DoaVj","phone":"styles_phone__3QIsG"};